import { Box, SxProps, Theme, Tooltip, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { formatDate } from "app/util/date/tools/common"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface ICampaignSummaryItemProps {
  title: string
  id: string
  value?: string | number | null | Date
  emptyLabel?: string
  tooltip?: string
  textarea?: boolean
  sxChildren?: SxProps<Theme>
}

export class CampaignSummaryItem extends React.PureComponent<ICampaignSummaryItemProps, {}> {
  public render() {
    const { title, value, sxChildren, children, tooltip, emptyLabel, textarea, id } = this.props
    const isEmpty = value === undefined || value === null || value === ""
    const formatedValue = isEmpty
      ? emptyLabel
        ? emptyLabel
        : translate("label.n/a")
      : value instanceof Date
        ? formatDate(value)
        : value
    return (
      <Tooltip title={tooltip || ""}>
        <div>
          <FlexBox id={id} vertical ai="start">
            <Typography id={`${id}-title`} color="textPrimary" fontSize=".8rem" fontWeight={600}>
              {title}
            </Typography>
            {value !== undefined && (
              <Tooltip title={formatedValue}>
                <Typography
                  id={`${id}-value`}
                  color={isEmpty ? "textSecondary" : "textPrimary"}
                  fontSize=".85rem"
                  disabled={textarea}
                  overflow={"hidden"}
                  whiteSpace={"nowrap"}
                  textOverflow={"ellipsis"}
                  width={"100%"}
                  sx={{
                    "ml": "1rem",
                    "pr": "1rem",
                    "&.textarea": {
                      border: "none",
                      minHeight: "5rem",
                      p: "1rem",
                      ml: 0,
                      backgroundColor: theme => theme.palette.background.default
                    }
                  }}
                  className={textarea ? "textarea" : ""}
                  component={textarea ? "textarea" : "p"}>
                  {formatedValue}
                </Typography>
              </Tooltip>
            )}
            {children && <Box sx={{ width: "100%", ...sxChildren }}>{children}</Box>}
          </FlexBox>
        </div>
      </Tooltip>
    )
  }
}
